import { render, staticRenderFns } from "./asRegister.vue?vue&type=template&id=3e7f9f25&scoped=true"
import script from "./asRegister.vue?vue&type=script&lang=js"
export * from "./asRegister.vue?vue&type=script&lang=js"
import style0 from "./asRegister.vue?vue&type=style&index=0&id=3e7f9f25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7f9f25",
  null
  
)

export default component.exports